<template>
    <div>
        <!--begin::Notice-->
        <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-6 col-centered create-report-card">
                <div class="card p-4 pb-9">
                    <div class="col-centered text-center">
                        <div class="custom-title pt-7">
                            Your scan is being run
                        </div>
                        <div class="custom-subheading pt-3">
                            Please wait for some moment while we compile your report.
                        </div>
                    </div>
                    <div class="form-body" style="padding-top: 2.9rem !important;">

                        <template v-for="(step, i) in steps">
                            <div :class="{['mt-6']: i !== 0}" :ref="step.ref.toString()"
                                 class="progress-container-fade">
                                <div class="progress-features">
                                    <div class="progress-compile-iconWrapper">
                                        <i :class="'mdi ' + step.icon + ' progress-compile-icon-fade'"></i>
                                    </div>
                                    <div class="progress-compile-dataWrapper">
                                        <div class="progress-compile-info">{{ step.name }}</div>
                                        <div class="progress-compile-percent">0%</div>
                                        <div class="progress progress-xs" style="margin-top: 5px;">
                                            <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="50"
                                                 class="progress-bar bg-faded" role="progressbar"
                                                 style="width: 0%;"></div>
                                        </div>
                                        <div class="progress-state--Wrapper">
                                            <i class="mdi mdi-check-circle progress-state-success"
                                               style="display: none"></i>
                                        </div>
                                    </div>
                                </div>
                                <a @click="goToCreateReport()" class="error" href="#" style="display: none">
                                    Server encountered error, please try again
                                </a>
                            </div>
                        </template>

                    </div>
                </div>
                <!--end::Notice-->
            </div>
        </div>
    </div>
</template>


<script>

   // import * as Promise from "bluebird";
   import random from 'random';
   import {
      CHANGE_COMPONENT,
      CHANGE_COMPILE_STEP,
      SAVE_REPORT_TO_DATABASE,
      SAVE_REPORT_TO_BLOCKCHAIN,
   } from '../../core/store/modules/report';
   import {
      PIC_UPLOAD
   } from '../../core/store/modules/report.picscan';
   import {mapGetters} from 'vuex';

   export default {
      data() {
         return {
            utils: {
               count_step: [],
               procedures: []
            },
            steps: [
               {ref: 'connecting-to-server', icon: 'mdi-cloud-outline', name: 'Analyzing Picture…'},
               {ref: 'tracing-route-server', icon: 'mdi-cloud-search-outline', name: 'Running AI Scripts…'},
               {ref: 'emptying-cache', icon: 'mdi-trash-can-outline', name: 'Connecting to Servers…'},
               {ref: 'running-antivirus', icon: 'mdi-shield-half-full', name: 'Matching Photos Semantics…'},
               {ref: 'analyzing-site', icon: 'mdi-page-previous-outline', name: 'Matching Photos Vectors…'},
               {ref: 'capturing-information', icon: 'mdi-folder-clock-outline', name: 'Compiling List…'},
            ],
            timer: {
               max: 100,
               speed: 900,
               counter: [],
               counterString: [],
               timerInterval: []
            }
         };
      },
      computed: {
         ...mapGetters([
            'compileStep',
            'reportFields'
         ])
      },
      methods: {
         // Capture upload pic for scan / Store pic computed hash to blockchain / Save
         saveScreenshot() {
            Promise.all([
               this.$store.dispatch(PIC_UPLOAD, 'picscan')
                   .then(() => this.$store.dispatch(SAVE_REPORT_TO_BLOCKCHAIN))
                   .then(() => this.$store.dispatch(SAVE_REPORT_TO_DATABASE))
            ]).then((res) => {
               console.log(res);
               this.utils.procedures.push({'saving': true});
            }).catch((e) => {
               console.log(e);
               this.utils.procedures.push({'saving': false});
            });
         },
         // Timer
         initSteps(i) {
            this.timer.counter[i] = 0;
            this.startProcessing(i);
         },
         startProcessing(i) {
            this.utils.count_step.push(i);
            let doc = this.$refs[this.steps[i].ref][0];
            let el0 = doc.querySelector('.progress-compile-iconWrapper');
            let el1 = doc.querySelector('.progress-compile-percent');
            let el2 = doc.querySelector('.progress-bar');
            this.timer.timerInterval[i] = setInterval(() => {
               this.setCounter(i);
               if (this.timer.counter[i] >= 60) {
                  doc.classList.remove('progress-container-fade');
                  doc.classList.add('progress-container-success');
                  el0.childNodes[0].classList.remove('progress-compile-icon-fade');
                  el0.childNodes[0].classList.add('progress-compile-icon');
                  el2.classList.remove('bg-faded');
                  el2.classList.add('bg-success');
               }
               if (this.timer.counter[i] >= this.timer.max) {
                  this.stopCounter(i);
               }
               el1.innerText = `${this.timer.counter[i]}%`;
               el2.style = `width: ${this.timer.counter[i]}%;`;
            }, this.timer.speed);
         },
         setCounter(i) {
            this.timer.counter[i] += random.int(1, 10);
            this.timer.counterString[i] = `width: ${this.timer.counter[i]}%;`;
         },
         stopCounter(i) {
            let doc = this.$refs[this.steps[i].ref][0];
            let el3 = doc.querySelector('.progress-state--Wrapper');
            this.timer.counter[i] = this.timer.max;
            this.timer.counterString[i] = 'width: 100%;';
            clearInterval(this.timer.timerInterval[i]);
            setTimeout(() => {
               el3.childNodes[0].style = 'display: block';
               this.$store.dispatch(CHANGE_COMPILE_STEP, i + 1);
            }, this.timer.speed);
         },
         savingEcounteredError() {
            let i = this.utils.count_step.reverse()[0];
            let doc = this.$refs[this.steps[i].ref][0];
            let el0 = doc.querySelector('.progress-compile-iconWrapper');
            let el2 = doc.querySelector('.progress-bar');
            let el4 = doc.querySelector('.error');
            doc.classList.remove('progress-container-fade');
            doc.classList.remove('progress-container-success');
            doc.classList.add('progress-container-danger');
            el0.childNodes[0].classList.remove('progress-compile-icon-fade');
            el0.childNodes[0].classList.remove('progress-compile-icon');
            el0.childNodes[0].classList.add('progress-compile-icon-danger');
            el2.classList.remove('bg-faded');
            el2.classList.add('bg-danger');
            el4.style = 'display: block';
            this.steps.forEach((el, index) => {
               if (i <= index) {
                  clearInterval(this.timer.timerInterval[index]);
               }
            });
         },
         //
         goToCreateReport() {
            window.location.reload();
         }
      },
      watch: {
         'compileStep'(i) {
            if (this.steps[i]) {
               this.initSteps(i);
            } else {
               this.utils.procedures.push({'loading': true});
            }
         },
         'utils.procedures'(procedures) {
            if (procedures[0] && procedures[1]) {
               if (procedures[0].saving && procedures[1].loading) {
                  setTimeout(() => {
                     this.$store.dispatch(CHANGE_COMPONENT, 'appAnalysisPicCreated');
                  }, 1000);
               } else {
                  this.savingEcounteredError();
               }
            } else {
               if (procedures[0].saving) {
                  // increase the speed
                  this.timer.speed -= 830;
               } else {
                  this.savingEcounteredError();
               }
            }
         }
      },
      mounted() {
         this.initSteps(0);
         this.saveScreenshot();
      }
   };
</script>

<style scoped>
    .error {
        color: red;
        font-size: 10px;
        padding-top: 3px;
        text-decoration: underline;
    }
</style>
